var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1290,
    height: 496,
    viewBox: "0 0 1290 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1153.49 435.069L1074.4 399.62L970.381 348.066L1056.12 252.11L1169.72 243.72L1230.59 359.286L1153.49 435.069Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.14 433.578L1150.74 365.524L1045.07 329.269L970.381 348.066L1150.71 365.843",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.11 308.99L1150.71 365.843L1074.4 399.62L1129.11 308.99Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.11 308.99L1230.59 359.286L1150.71 365.843L1169.72 243.72C1168.44 246.833 1129.11 308.99 1129.11 308.99ZM1129.11 308.99L1045.07 329.269L1056.12 252.11L1129.71 309.095",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.49 439.885C1156.48 439.885 1158.9 437.729 1158.9 435.068C1158.9 432.408 1156.48 430.252 1153.49 430.252C1150.5 430.252 1148.08 432.408 1148.08 435.068C1148.08 437.729 1150.5 439.885 1153.49 439.885Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.4 435.068C1158.4 437.399 1156.26 439.385 1153.49 439.385C1150.72 439.385 1148.58 437.399 1148.58 435.068C1148.58 432.738 1150.72 430.752 1153.49 430.752C1156.26 430.752 1158.4 432.738 1158.4 435.068Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.72 251.814C1174.75 251.814 1178.82 248.19 1178.82 243.72C1178.82 239.251 1174.75 235.627 1169.72 235.627C1164.7 235.627 1160.63 239.251 1160.63 243.72C1160.63 248.19 1164.7 251.814 1169.72 251.814Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.32 243.72C1178.32 247.861 1174.53 251.314 1169.72 251.314C1164.92 251.314 1161.13 247.861 1161.13 243.72C1161.13 239.58 1164.92 236.127 1169.72 236.127C1174.53 236.127 1178.32 239.58 1178.32 243.72Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.07 338.902C1051.05 338.902 1055.9 334.589 1055.9 329.269C1055.9 323.948 1051.05 319.635 1045.07 319.635C1039.09 319.635 1034.25 323.948 1034.25 329.269C1034.25 334.589 1039.09 338.902 1045.07 338.902Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.4 329.269C1055.4 334.26 1050.83 338.402 1045.07 338.402C1039.31 338.402 1034.75 334.26 1034.75 329.269C1034.75 324.278 1039.31 320.135 1045.07 320.135C1050.83 320.135 1055.4 324.278 1055.4 329.269Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.59 368.919C1236.57 368.919 1241.42 364.606 1241.42 359.286C1241.42 353.965 1236.57 349.652 1230.59 349.652C1224.62 349.652 1219.77 353.965 1219.77 359.286C1219.77 364.606 1224.62 368.919 1230.59 368.919Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.92 359.286C1240.92 364.277 1236.35 368.419 1230.59 368.419C1224.84 368.419 1220.27 364.277 1220.27 359.286C1220.27 354.294 1224.84 350.152 1230.59 350.152C1236.35 350.152 1240.92 354.294 1240.92 359.286Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.47 373.622C1155.49 373.622 1159.56 369.999 1159.56 365.529C1159.56 361.059 1155.49 357.436 1150.47 357.436C1145.44 357.436 1141.37 361.059 1141.37 365.529C1141.37 369.999 1145.44 373.622 1150.47 373.622Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.06 365.529C1159.06 369.669 1155.27 373.122 1150.47 373.122C1145.66 373.122 1141.87 369.669 1141.87 365.529C1141.87 361.388 1145.66 357.936 1150.47 357.936C1155.27 357.936 1159.06 361.388 1159.06 365.529Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.12 260.203C1061.14 260.203 1065.21 256.58 1065.21 252.11C1065.21 247.64 1061.14 244.017 1056.12 244.017C1051.1 244.017 1047.03 247.64 1047.03 252.11C1047.03 256.58 1051.1 260.203 1056.12 260.203Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.71 252.11C1064.71 256.25 1060.92 259.703 1056.12 259.703C1051.32 259.703 1047.53 256.25 1047.53 252.11C1047.53 247.969 1051.32 244.517 1056.12 244.517C1060.92 244.517 1064.71 247.969 1064.71 252.11Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.381 352.883C973.37 352.883 975.793 350.726 975.793 348.066C975.793 345.406 973.37 343.25 970.381 343.25C967.392 343.25 964.969 345.406 964.969 348.066C964.969 350.726 967.392 352.883 970.381 352.883Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.293 348.066C975.293 350.397 973.15 352.383 970.381 352.383C967.612 352.383 965.469 350.397 965.469 348.066C965.469 345.735 967.612 343.75 970.381 343.75C973.15 343.75 975.293 345.735 975.293 348.066Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.4 407.713C1079.43 407.713 1083.5 404.089 1083.5 399.62C1083.5 395.15 1079.43 391.526 1074.4 391.526C1069.38 391.526 1065.31 395.15 1065.31 399.62C1065.31 404.089 1069.38 407.713 1074.4 407.713Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083 399.62C1083 403.76 1079.21 407.213 1074.4 407.213C1069.6 407.213 1065.81 403.76 1065.81 399.62C1065.81 395.479 1069.6 392.026 1074.4 392.026C1079.21 392.026 1083 395.479 1083 399.62Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.11 314.768C1132.7 314.768 1135.6 312.181 1135.6 308.99C1135.6 305.799 1132.7 303.212 1129.11 303.212C1125.53 303.212 1122.62 305.799 1122.62 308.99C1122.62 312.181 1125.53 314.768 1129.11 314.768Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.1 308.99C1135.1 311.852 1132.48 314.268 1129.11 314.268C1125.75 314.268 1123.12 311.852 1123.12 308.99C1123.12 306.128 1125.75 303.712 1129.11 303.712C1132.48 303.712 1135.1 306.128 1135.1 308.99Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1047.19 136.645L1126.83 12.1067L1278.92 108.587L1273.94 72.6509L1081.48 32.2896L973.637 111.54L1000.73 177.498L1098.62 220.32L1147.85 146.98L1048.3 136.153L997.968 11.6145L1000.73 177.498L949.855 242.472L907.825 229.676L1002.4 177.498",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.83 12.1067L997.968 11.6145L973.637 111.54L907.825 229.676",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M973.637 111.54L1046.64 136.645L1272.28 73.6351L1147.85 146.98L1126.83 12.1067L1081.48 32.2896L1047.74 136.153L1098.62 220.32L949.855 242.472L1147.85 146.98",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.64 136.645L1000.73 177.498",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.62 220.32L1278.92 108.587L1147.85 146.98L1081.48 32.2896L997.968 11.6145",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.74 143.535C1052.33 143.535 1056.04 140.23 1056.04 136.153C1056.04 132.075 1052.33 128.77 1047.74 128.77C1043.16 128.77 1039.45 132.075 1039.45 136.153C1039.45 140.23 1043.16 143.535 1047.74 143.535Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.54 136.153C1055.54 139.9 1052.11 143.035 1047.74 143.035C1043.38 143.035 1039.95 139.9 1039.95 136.153C1039.95 132.405 1043.38 129.27 1047.74 129.27C1052.11 129.27 1055.54 132.405 1055.54 136.153Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.73 187.341C1006.84 187.341 1011.79 182.934 1011.79 177.498C1011.79 172.062 1006.84 167.655 1000.73 167.655C994.625 167.655 989.673 172.062 989.673 177.498C989.673 182.934 994.625 187.341 1000.73 187.341Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.29 177.498C1011.29 182.605 1006.62 186.841 1000.73 186.841C994.844 186.841 990.173 182.605 990.173 177.498C990.173 172.391 994.844 168.155 1000.73 168.155C1006.62 168.155 1011.29 172.391 1011.29 177.498Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.48 37.211C1084.53 37.211 1087.01 35.0075 1087.01 32.2894C1087.01 29.5713 1084.53 27.3679 1081.48 27.3679C1078.43 27.3679 1075.95 29.5713 1075.95 32.2894C1075.95 35.0075 1078.43 37.211 1081.48 37.211Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.51 32.2894C1086.51 34.6782 1084.31 36.711 1081.48 36.711C1078.65 36.711 1076.45 34.6782 1076.45 32.2894C1076.45 29.9007 1078.65 27.8679 1081.48 27.8679C1084.31 27.8679 1086.51 29.9007 1086.51 32.2894Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.83 24.9027C1134.46 24.9027 1140.65 19.394 1140.65 12.5988C1140.65 5.80356 1134.46 0.294922 1126.83 0.294922C1119.19 0.294922 1113 5.80356 1113 12.5988C1113 19.394 1119.19 24.9027 1126.83 24.9027Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.15 12.5988C1140.15 19.0647 1134.24 24.4027 1126.83 24.4027C1119.41 24.4027 1113.5 19.0647 1113.5 12.5988C1113.5 6.13287 1119.41 0.794922 1126.83 0.794922C1134.24 0.794922 1140.15 6.13287 1140.15 12.5988Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.968 21.4577C1004.08 21.4577 1009.03 17.0508 1009.03 11.6146C1009.03 6.17838 1004.08 1.77148 997.968 1.77148C991.86 1.77148 986.908 6.17838 986.908 11.6146C986.908 17.0508 991.86 21.4577 997.968 21.4577Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.53 11.6146C1008.53 16.7215 1003.86 20.9577 997.968 20.9577C992.08 20.9577 987.408 16.7215 987.408 11.6146C987.408 6.50769 992.08 2.27148 997.968 2.27148C1003.86 2.27148 1008.53 6.50769 1008.53 11.6146Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.85 156.823C1153.95 156.823 1158.9 152.416 1158.9 146.98C1158.9 141.544 1153.95 137.137 1147.85 137.137C1141.74 137.137 1136.79 141.544 1136.79 146.98C1136.79 152.416 1141.74 156.823 1147.85 156.823Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.4 146.98C1158.4 152.087 1153.73 156.323 1147.85 156.323C1141.96 156.323 1137.29 152.087 1137.29 146.98C1137.29 141.873 1141.96 137.637 1147.85 137.637C1153.73 137.637 1158.4 141.873 1158.4 146.98Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.92 113.017C1281.97 113.017 1284.45 110.813 1284.45 108.095C1284.45 105.377 1281.97 103.174 1278.92 103.174C1275.86 103.174 1273.39 105.377 1273.39 108.095C1273.39 110.813 1275.86 113.017 1278.92 113.017Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.95 108.095C1283.95 110.484 1281.75 112.517 1278.92 112.517C1276.08 112.517 1273.89 110.484 1273.89 108.095C1273.89 105.706 1276.08 103.674 1278.92 103.674C1281.75 103.674 1283.95 105.706 1283.95 108.095Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.94 82.0019C1280.05 82.0019 1285 77.595 1285 72.1588C1285 66.7226 1280.05 62.3157 1273.94 62.3157C1267.83 62.3157 1262.88 66.7226 1262.88 72.1588C1262.88 77.595 1267.83 82.0019 1273.94 82.0019Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.5 72.1588C1284.5 77.2656 1279.83 81.5019 1273.94 81.5019C1268.05 81.5019 1263.38 77.2657 1263.38 72.1588C1263.38 67.0519 1268.05 62.8157 1273.94 62.8157C1279.83 62.8157 1284.5 67.0519 1284.5 72.1588Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.62 231.64C1106.26 231.64 1112.45 226.131 1112.45 219.336C1112.45 212.541 1106.26 207.032 1098.62 207.032C1090.99 207.032 1084.8 212.541 1084.8 219.336C1084.8 226.131 1090.99 231.64 1098.62 231.64Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.95 219.336C1111.95 225.802 1106.04 231.14 1098.62 231.14C1091.21 231.14 1085.3 225.802 1085.3 219.336C1085.3 212.87 1091.21 207.532 1098.62 207.532C1106.04 207.532 1111.95 212.87 1111.95 219.336Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M833.918 303.658L860.327 410.388L969.419 347.971L881.104 492.455L990.196 488.987L907.513 229.685L700.02 223.25L796.26 322.925L862.057 343.733L833.918 303.658Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M969.418 347.97L862.057 343.732L907.513 229.685L668.122 358.757L796.26 322.925L833.918 303.658L749.939 416.553L719.204 435.816L881.104 492.454L860.327 410.387L907.513 229.685L833.052 303.658",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M667.472 358.565L718.984 435.624L699.589 222.867L667.687 358.757L749.939 416.553L796.26 322.925L860.327 410.388L749.504 416.553L881.713 491.147",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.493 308.817C837.078 308.817 839.985 306.23 839.985 303.038C839.985 299.847 837.078 297.26 833.493 297.26C829.907 297.26 827.001 299.847 827.001 303.038C827.001 306.23 829.907 308.817 833.493 308.817Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.485 303.038C839.485 305.9 836.859 308.317 833.493 308.317C830.127 308.317 827.501 305.9 827.501 303.038C827.501 300.177 830.127 297.76 833.493 297.76C836.859 297.76 839.485 300.177 839.485 303.038Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.419 357.681C975.396 357.681 980.242 353.368 980.242 348.048C980.242 342.727 975.396 338.414 969.419 338.414C963.441 338.414 958.595 342.727 958.595 348.048C958.595 353.368 963.441 357.681 969.419 357.681Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.742 348.048C979.742 353.039 975.177 357.181 969.419 357.181C963.661 357.181 959.095 353.039 959.095 348.048C959.095 343.057 963.661 338.914 969.419 338.914C975.177 338.914 979.742 343.057 979.742 348.048Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.153 496C884.546 496 886.485 494.274 886.485 492.145C886.485 490.015 884.546 488.289 882.153 488.289C879.761 488.289 877.822 490.015 877.822 492.145C877.822 494.274 879.761 496 882.153 496Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.985 492.145C885.985 493.944 884.326 495.5 882.153 495.5C879.981 495.5 878.322 493.944 878.322 492.145C878.322 490.345 879.981 488.789 882.153 488.789C884.326 488.789 885.985 490.345 885.985 492.145Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.38 495.576C994.565 495.576 997.957 492.556 997.957 488.832C997.957 485.107 994.565 482.087 990.38 482.087C986.195 482.087 982.802 485.107 982.802 488.832C982.802 492.556 986.195 495.576 990.38 495.576Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.457 488.832C997.457 492.227 994.345 495.076 990.38 495.076C986.415 495.076 983.302 492.227 983.302 488.832C983.302 485.436 986.415 482.587 990.38 482.587C994.345 482.587 997.457 485.436 997.457 488.832Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.112 420.431C866.09 420.431 870.935 416.118 870.935 410.798C870.935 405.477 866.09 401.164 860.112 401.164C854.134 401.164 849.288 405.477 849.288 410.798C849.288 416.118 854.134 420.431 860.112 420.431Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.435 410.798C870.435 415.789 865.87 419.931 860.112 419.931C854.354 419.931 849.788 415.789 849.788 410.798C849.788 405.806 854.354 401.664 860.112 401.664C865.87 401.664 870.435 405.806 870.435 410.798Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.938 365.428C672.123 365.428 675.515 362.409 675.515 358.684C675.515 354.959 672.123 351.939 667.938 351.939C663.753 351.939 660.36 354.959 660.36 358.684C660.36 362.409 663.753 365.428 667.938 365.428Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.015 358.684C675.015 362.079 671.903 364.928 667.938 364.928C663.973 364.928 660.86 362.079 660.86 358.684C660.86 355.288 663.973 352.439 667.938 352.439C671.903 352.439 675.015 355.288 675.015 358.684Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.025 442.592C723.21 442.592 726.603 439.572 726.603 435.847C726.603 432.123 723.21 429.103 719.025 429.103C714.84 429.103 711.448 432.123 711.448 435.847C711.448 439.572 714.84 442.592 719.025 442.592Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.103 435.847C726.103 439.243 722.99 442.092 719.025 442.092C715.06 442.092 711.948 439.243 711.948 435.847C711.948 432.452 715.06 429.603 719.025 429.603C722.99 429.603 726.103 432.452 726.103 435.847Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.807 426.023C755.784 426.023 760.63 421.71 760.63 416.389C760.63 411.069 755.784 406.756 749.807 406.756C743.829 406.756 738.983 411.069 738.983 416.389C738.983 421.71 743.829 426.023 749.807 426.023Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.13 416.389C760.13 421.38 755.564 425.523 749.807 425.523C744.049 425.523 739.483 421.38 739.483 416.389C739.483 411.398 744.049 407.256 749.807 407.256C755.564 407.256 760.13 411.398 760.13 416.389Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.945 347.597C864.337 347.597 866.276 345.871 866.276 343.741C866.276 341.612 864.337 339.886 861.945 339.886C859.553 339.886 857.613 341.612 857.613 343.741C857.613 345.871 859.553 347.597 861.945 347.597Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.776 343.741C865.776 345.541 864.117 347.097 861.945 347.097C859.772 347.097 858.113 345.541 858.113 343.741C858.113 341.942 859.772 340.386 861.945 340.386C864.117 340.386 865.776 341.942 865.776 343.741Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.086 329.515C800.271 329.515 803.664 326.495 803.664 322.77C803.664 319.045 800.271 316.026 796.086 316.026C791.901 316.026 788.509 319.045 788.509 322.77C788.509 326.495 791.901 329.515 796.086 329.515Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.164 322.77C803.164 326.166 800.051 329.015 796.086 329.015C792.121 329.015 789.009 326.166 789.009 322.77C789.009 319.375 792.121 316.526 796.086 316.526C800.051 316.526 803.164 319.375 803.164 322.77Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M498.133 435.068L419.044 399.62L315.021 348.066L400.761 257.122L519.483 225.492L575.235 359.286L498.133 435.068Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.785 433.578L495.378 365.524L389.712 329.269L315.021 348.066L495.348 365.843",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.751 308.99L495.348 365.843L419.044 399.62L473.751 308.99Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.751 308.99L575.235 359.286L495.348 365.843L519.483 225.492C518.203 228.605 473.751 308.99 473.751 308.99ZM473.751 308.99L389.712 329.269L400.761 257.122L474.35 309.095",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.133 439.885C501.122 439.885 503.545 437.729 503.545 435.068C503.545 432.408 501.122 430.252 498.133 430.252C495.144 430.252 492.721 432.408 492.721 435.068C492.721 437.729 495.144 439.885 498.133 439.885Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.045 435.068C503.045 437.399 500.902 439.385 498.133 439.385C495.364 439.385 493.221 437.399 493.221 435.068C493.221 432.738 495.364 430.752 498.133 430.752C500.902 430.752 503.045 432.738 503.045 435.068Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.712 338.902C395.69 338.902 400.536 334.589 400.536 329.269C400.536 323.948 395.69 319.635 389.712 319.635C383.734 319.635 378.888 323.948 378.888 329.269C378.888 334.589 383.734 338.902 389.712 338.902Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.036 329.269C400.036 334.26 395.47 338.402 389.712 338.402C383.954 338.402 379.388 334.26 379.388 329.269C379.388 324.278 383.954 320.135 389.712 320.135C395.47 320.135 400.036 324.278 400.036 329.269Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.235 368.919C581.213 368.919 586.059 364.606 586.059 359.286C586.059 353.965 581.213 349.652 575.235 349.652C569.257 349.652 564.411 353.965 564.411 359.286C564.411 364.606 569.257 368.919 575.235 368.919Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.559 359.286C585.559 364.277 580.993 368.419 575.235 368.419C569.477 368.419 564.911 364.277 564.911 359.286C564.911 354.295 569.477 350.152 575.235 350.152C580.993 350.152 585.559 354.295 585.559 359.286Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.107 373.622C500.129 373.622 504.2 369.999 504.2 365.529C504.2 361.059 500.129 357.436 495.107 357.436C490.085 357.436 486.014 361.059 486.014 365.529C486.014 369.999 490.085 373.622 495.107 373.622Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.7 365.529C503.7 369.669 499.909 373.122 495.107 373.122C490.305 373.122 486.514 369.669 486.514 365.529C486.514 361.388 490.305 357.936 495.107 357.936C499.909 357.936 503.7 361.388 503.7 365.529Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.021 352.883C318.01 352.883 320.433 350.727 320.433 348.067C320.433 345.406 318.01 343.25 315.021 343.25C312.032 343.25 309.609 345.406 309.609 348.067C309.609 350.727 312.032 352.883 315.021 352.883Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.933 348.067C319.933 350.397 317.79 352.383 315.021 352.383C312.252 352.383 310.109 350.397 310.109 348.067C310.109 345.736 312.252 343.75 315.021 343.75C317.79 343.75 319.933 345.736 319.933 348.067Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.044 407.713C424.066 407.713 428.137 404.089 428.137 399.62C428.137 395.15 424.066 391.526 419.044 391.526C414.022 391.526 409.951 395.15 409.951 399.62C409.951 404.089 414.022 407.713 419.044 407.713Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.637 399.62C427.637 403.76 423.846 407.213 419.044 407.213C414.242 407.213 410.451 403.76 410.451 399.62C410.451 395.479 414.242 392.026 419.044 392.026C423.846 392.026 427.637 395.479 427.637 399.62Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.751 314.768C477.337 314.768 480.244 312.181 480.244 308.99C480.244 305.799 477.337 303.212 473.751 303.212C470.166 303.212 467.259 305.799 467.259 308.99C467.259 312.181 470.166 314.768 473.751 314.768Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.744 308.99C479.744 311.852 477.117 314.268 473.751 314.268C470.386 314.268 467.759 311.852 467.759 308.99C467.759 306.128 470.386 303.712 473.751 303.712C477.117 303.712 479.744 306.128 479.744 308.99Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.468 12.1067L342.608 11.6145L318.278 111.54L252.465 229.676",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M318.278 111.54L391.278 136.645L616.922 73.6351L492.486 146.98L471.468 12.1067L426.12 32.2896L392.384 136.153L443.262 220.32L294.495 242.472L492.486 146.98",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.278 136.645L345.373 177.498",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M342.608 11.6145L426.12 32.2896L492.486 146.98L623.558 108.587L443.262 220.32",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.124 240.011C260.232 240.011 265.183 235.604 265.183 230.168C265.183 224.732 260.232 220.325 254.124 220.325C248.016 220.325 243.065 224.732 243.065 230.168C243.065 235.604 248.016 240.011 254.124 240.011Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.683 230.168C264.683 235.275 260.012 239.511 254.124 239.511C248.236 239.511 243.565 235.275 243.565 230.168C243.565 225.061 248.236 220.825 254.124 220.825C260.012 220.825 264.683 225.061 264.683 230.168Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.495 249.854C299.076 249.854 302.789 246.549 302.789 242.472C302.789 238.395 299.076 235.089 294.495 235.089C289.914 235.089 286.201 238.395 286.201 242.472C286.201 246.549 289.914 249.854 294.495 249.854Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.289 242.472C302.289 246.219 298.856 249.354 294.495 249.354C290.134 249.354 286.701 246.219 286.701 242.472C286.701 238.724 290.134 235.589 294.495 235.589C298.856 235.589 302.289 238.724 302.289 242.472Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.558 303.659L204.967 410.388L314.058 347.971L225.744 492.455L334.835 488.987L252.153 229.685L65.1394 205.022L140.9 322.925L206.697 343.733L178.558 303.659Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.058 347.971L206.697 343.733L252.152 229.685L12.7617 358.757L140.9 322.925L178.558 303.658L94.5793 416.553L63.844 435.816L225.743 492.455L204.967 410.388L252.152 229.685L177.692 303.658",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1116 358.566L63.6239 435.624L64.7093 204.64L12.3266 358.757L94.5794 416.553L140.9 322.925L204.967 410.388L94.1442 416.553L226.353 491.147",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.511 233.048C254.903 233.048 256.842 231.322 256.842 229.193C256.842 227.063 254.903 225.337 252.511 225.337C250.119 225.337 248.179 227.063 248.179 229.193C248.179 231.322 250.119 233.048 252.511 233.048Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.342 229.193C256.342 230.993 254.683 232.548 252.511 232.548C250.339 232.548 248.679 230.993 248.679 229.193C248.679 227.393 250.339 225.837 252.511 225.837C254.683 225.837 256.342 227.393 256.342 229.193Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 308.817C181.718 308.817 184.625 306.23 184.625 303.039C184.625 299.847 181.718 297.26 178.133 297.26C174.547 297.26 171.641 299.847 171.641 303.039C171.641 306.23 174.547 308.817 178.133 308.817Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.125 303.039C184.125 305.901 181.499 308.317 178.133 308.317C174.767 308.317 172.141 305.901 172.141 303.039C172.141 300.177 174.767 297.76 178.133 297.76C181.499 297.76 184.125 300.177 184.125 303.039Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.059 357.682C320.036 357.682 324.882 353.368 324.882 348.048C324.882 342.728 320.036 338.415 314.059 338.415C308.081 338.415 303.235 342.728 303.235 348.048C303.235 353.368 308.081 357.682 314.059 357.682Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.382 348.048C324.382 353.039 319.817 357.182 314.059 357.182C308.301 357.182 303.735 353.039 303.735 348.048C303.735 343.057 308.301 338.915 314.059 338.915C319.817 338.915 324.382 343.057 324.382 348.048Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.793 496C229.185 496 231.125 494.274 231.125 492.145C231.125 490.016 229.185 488.29 226.793 488.29C224.401 488.29 222.462 490.016 222.462 492.145C222.462 494.274 224.401 496 226.793 496Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.625 492.145C230.625 493.945 228.966 495.5 226.793 495.5C224.621 495.5 222.962 493.945 222.962 492.145C222.962 490.345 224.621 488.79 226.793 488.79C228.966 488.79 230.625 490.345 230.625 492.145Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.02 495.576C339.205 495.576 342.597 492.557 342.597 488.832C342.597 485.107 339.205 482.087 335.02 482.087C330.835 482.087 327.442 485.107 327.442 488.832C327.442 492.557 330.835 495.576 335.02 495.576Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.097 488.832C342.097 492.227 338.985 495.076 335.02 495.076C331.055 495.076 327.942 492.227 327.942 488.832C327.942 485.436 331.055 482.587 335.02 482.587C338.985 482.587 342.097 485.436 342.097 488.832Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.752 420.431C210.729 420.431 215.575 416.118 215.575 410.798C215.575 405.477 210.729 401.164 204.752 401.164C198.774 401.164 193.928 405.477 193.928 410.798C193.928 416.118 198.774 420.431 204.752 420.431Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.075 410.798C215.075 415.789 210.51 419.931 204.752 419.931C198.994 419.931 194.428 415.789 194.428 410.798C194.428 405.807 198.994 401.664 204.752 401.664C210.51 401.664 215.075 405.807 215.075 410.798Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5776 365.428C16.7626 365.428 20.1552 362.409 20.1552 358.684C20.1552 354.959 16.7626 351.94 12.5776 351.94C8.39261 351.94 5 354.959 5 358.684C5 362.409 8.39261 365.428 12.5776 365.428Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6552 358.684C19.6552 362.08 16.5428 364.928 12.5776 364.928C8.6124 364.928 5.5 362.08 5.5 358.684C5.5 355.289 8.6124 352.44 12.5776 352.44C16.5428 352.44 19.6552 355.289 19.6552 358.684Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1191 214.583C71.0968 214.583 75.9428 210.27 75.9428 204.949C75.9428 199.629 71.0968 195.316 65.1191 195.316C59.1413 195.316 54.2954 199.629 54.2954 204.949C54.2954 210.27 59.1413 214.583 65.1191 214.583Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4428 204.949C75.4428 209.941 70.8771 214.083 65.1191 214.083C59.3611 214.083 54.7954 209.941 54.7954 204.949C54.7954 199.958 59.3611 195.816 65.1191 195.816C70.8771 195.816 75.4428 199.958 75.4428 204.949Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.665 442.592C67.85 442.592 71.2426 439.572 71.2426 435.848C71.2426 432.123 67.85 429.103 63.665 429.103C59.48 429.103 56.0874 432.123 56.0874 435.848C56.0874 439.572 59.48 442.592 63.665 442.592Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7426 435.848C70.7426 439.243 67.6302 442.092 63.665 442.092C59.6998 442.092 56.5874 439.243 56.5874 435.848C56.5874 432.452 59.6998 429.603 63.665 429.603C67.6302 429.603 70.7426 432.452 70.7426 435.848Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4465 426.023C100.424 426.023 105.27 421.71 105.27 416.389C105.27 411.069 100.424 406.756 94.4465 406.756C88.4687 406.756 83.6228 411.069 83.6228 416.389C83.6228 421.71 88.4687 426.023 94.4465 426.023Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77 416.389C104.77 421.381 100.204 425.523 94.4465 425.523C88.6885 425.523 84.1228 421.381 84.1228 416.389C84.1228 411.398 88.6885 407.256 94.4465 407.256C100.204 407.256 104.77 411.398 104.77 416.389Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.585 347.597C208.977 347.597 210.916 345.871 210.916 343.742C210.916 341.613 208.977 339.886 206.585 339.886C204.192 339.886 202.253 341.613 202.253 343.742C202.253 345.871 204.192 347.597 206.585 347.597Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.416 343.742C210.416 345.542 208.757 347.097 206.585 347.097C204.412 347.097 202.753 345.542 202.753 343.742C202.753 341.942 204.412 340.386 206.585 340.386C208.757 340.386 210.416 341.942 210.416 343.742Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.726 329.515C144.911 329.515 148.304 326.495 148.304 322.77C148.304 319.046 144.911 316.026 140.726 316.026C136.541 316.026 133.148 319.046 133.148 322.77C133.148 326.495 136.541 329.515 140.726 329.515Z",
    fill: "#E8E8E8",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.804 322.77C147.804 326.166 144.691 329.015 140.726 329.015C136.761 329.015 133.648 326.166 133.648 322.77C133.648 319.375 136.761 316.526 140.726 316.526C144.691 316.526 147.804 319.375 147.804 322.77Z",
    stroke: "#E8E8E8",
    strokeOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomGradient);
export default __webpack_public_path__ + "static/media/bottom_gradient.cd872289b4287e4410b5150199294eb1.svg";
export { ForwardRef as ReactComponent };